import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { map, Observable } from 'rxjs';
import { GET_MANUAL_SUBMISSION_INFO } from '../queries/energy-credit.queries';
import { FacilityAssignment } from '../../users/models/facility-assignment';
import { localStorageConstants } from 'src/app/shared/services';

export type ManualSubmissionInfo = {
  status:
    | 'NotFound'
    | 'Failed'
    | 'NotAllowed'
    | 'NotEnergyCreditsEnabled'
    | 'SubmittedInClaytonGO'
    | 'Exists'
    | 'Unknown';
  longSerialNumber: string;
  submissionId?: string;
  errorMessage?: string;
};

type ManualSubmissionInfoResult = {
  GetManualSubmissionInfo: {
    Status: string;
    LongSerialNumber: string;
    SubmissionId?: string;
    ErrorMessage?: string;
  };
};
@Injectable({
  providedIn: 'root',
})
export class ManualSubmissionService {
  constructor(private apolloClient: Apollo) {}

  getManualSubmission(
    serialNumber: string,
    emailAddress: string,
  ): Observable<ManualSubmissionInfo> {
    // Support-only users may have no facility assignments provisioned, so the
    // stored value can be absent. Fall back to an empty list rather than
    // throwing on .map — the backend answers NotAllowed for an empty scope.
    const facilityAssignments: FacilityAssignment[] =
      this.getFacilityAssignments();
    return this.apolloClient
      .query<ManualSubmissionInfoResult>({
        query: GET_MANUAL_SUBMISSION_INFO,
        variables: {
          serialNumber: serialNumber,
          userFacilities: facilityAssignments.map(
            (i) => i.Facility.KeyChain.LegacyId,
          ),
          userEmail: emailAddress,
        },
      })
      .pipe(
        map((value) => {
          return {
            status: value.data.GetManualSubmissionInfo.Status as any,
            longSerialNumber:
              value.data.GetManualSubmissionInfo.LongSerialNumber,
            submissionId: value.data.GetManualSubmissionInfo.SubmissionId,
            errorMessage: value.data.GetManualSubmissionInfo.ErrorMessage,
          };
        }),
      );
  }

  hasFacilityAssignments(): boolean {
    return this.getFacilityAssignments().length > 0;
  }

  private getFacilityAssignments(): FacilityAssignment[] {
    try {
      const stored = JSON.parse(
        localStorage.getItem(localStorageConstants.USER_FACILITIES_KEY),
      );
      return Array.isArray(stored) ? stored : [];
    } catch {
      return [];
    }
  }
}
